export const RollCallBreakSummaryReport = [
    {
        "s_no": 1,
        "biometric_id": 1,
        "employee": "Baji",
        "date": "3/25/2025 12:00:00 AM",
        "status": "Missed Swipe",
        "no_of_breaks": "",
        "break_hrs": "",
        "work_hrs": "",
        "in_time": "10:04:55",
        "out_time": "",
        "duration": "00:00"
    },
    {
        "s_no": 2,
        "biometric_id": 2,
        "employee": "Ali",
        "date": "3/25/2025 12:00:00 AM",
        "status": "Missed Swipe",
        "no_of_breaks": "",
        "break_hrs": "",
        "work_hrs": "",
        "in_time": "10:24:33",
        "out_time": "",
        "duration": "00:00"
    },
    {
        "s_no": 3,
        "biometric_id": 3,
        "employee": "Rajesh",
        "date": "3/25/2025 12:00:00 AM",
        "status": "Missed Swipe",
        "no_of_breaks": "",
        "break_hrs": "",
        "work_hrs": "",
        "in_time": "10:48:22",
        "out_time": "",
        "duration": "00:00"
    },
    {
        "s_no": 4,
        "biometric_id": 4,
        "employee": "Babji",
        "date": "3/25/2025 12:00:00 AM",
        "status": "Missed Swipe",
        "no_of_breaks": "",
        "break_hrs": "",
        "work_hrs": "",
        "in_time": "09:59:14",
        "out_time": "",
        "duration": "00:00"
    },
    {
        "s_no": 5,
        "biometric_id": 6,
        "employee": "Chandu",
        "date": "3/25/2025 12:00:00 AM",
        "status": "Missed Swipe",
        "no_of_breaks": "",
        "break_hrs": "",
        "work_hrs": "",
        "in_time": "10:11:28",
        "out_time": "",
        "duration": "00:00"
    },
    {
        "s_no": 6,
        "biometric_id": 8,
        "employee": "Das",
        "date": "3/25/2025 12:00:00 AM",
        "status": "Missed Swipe",
        "no_of_breaks": "",
        "break_hrs": "",
        "work_hrs": "",
        "in_time": "10:04:52",
        "out_time": "",
        "duration": "00:00"
    },
    {
        "s_no": 7,
        "biometric_id": 7,
        "employee": "Haleema",
        "date": "3/25/2025 12:00:00 AM",
        "status": "Missed Swipe",
        "no_of_breaks": "",
        "break_hrs": "",
        "work_hrs": "",
        "in_time": "10:26:31",
        "out_time": "",
        "duration": "00:00"
    }
]
